export default __webpack_public_path__ + "static/media/step-5.37936d86.webp";